import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/GOV_CO.png'
import _imports_1 from '../../assets/images/GO.png'
import _imports_2 from '../../assets/images/CentrodeRelevoMinticCall.png'
import _imports_3 from '../../assets/images/CentrodeRelevoMinticCallConVer.png'
import _imports_4 from '../../assets/images/CentrodeRelevoMinticInt.png'


const _hoisted_1 = { class: "bg-curaduriaDark" }
const _hoisted_2 = {
  key: 0,
  class: "bg-monteria-banner"
}
const _hoisted_3 = { class: "max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8 pb-20" }
const _hoisted_4 = {
  class: "-mx-5 -my-2 flex flex-wrap justify-center",
  "aria-label": "Footer"
}
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = { class: "mt-8 flex justify-center space-x-6" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = { class: "mt-6 xl:mt-2 flex flex-col text-center w-full" }
const _hoisted_10 = { class: "text-sm font-semibold text-white tracking-wider uppercase" }
const _hoisted_11 = { class: "mt-6 xl:mt-2 flex flex-row w-full" }
const _hoisted_12 = { class: "mt-6 xl:mt-2 flex flex-col text-center w-full" }
const _hoisted_13 = { class: "mt-4 text-base text-white" }
const _hoisted_14 = { class: "mt-4 text-base text-white" }
const _hoisted_15 = { class: "mt-4 text-base text-white" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-base text-white" }, "info@curaduria2monteria.com", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-base text-white" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Correo notificaciones juidiciales:"),
  /*#__PURE__*/_createTextVNode(" info@curaduria2monteria.com ")
], -1)
const _hoisted_18 = { class: "mt-4 text-base text-white" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-6 xl:mt-2 flex flex-col text-center w-full\"><p class=\"mt-4 text-base text-white\"><a href=\"https://www.supernotariado.gov.co/\" target=\"_blank\">Superintendencia de Notariado y Registro</a></p><p class=\"mt-4 text-base text-white\"><a href=\"https://www.minvivienda.gov.co/\" target=\"_blank\">Ministerio de vivienda</a></p><p class=\"mt-4 text-base text-white\"><a href=\"https://curadoresurbanos.org/\" target=\"_blank\">Colegio Nacional de curadores Urbanos</a></p><p class=\"mt-4 text-base text-white\"><a href=\"https://www.monteria.gov.co/\" target=\"_blank\">Alcaldía de Montería</a></p><div class=\"flex flex-row justify-center\"><p class=\"mt-4\"><a href=\"https://www.gov.co/\" target=\"_blank\"><img src=\"" + _imports_0 + "\" class=\"h-10\" alt=\"GOV.CO\"></a></p><p class=\"mt-4 ml-2\"><a href=\"https://www.colombia.co/\" target=\"_blank\"><img src=\"" + _imports_1 + "\" class=\"h-10\" alt=\"Colombia.co\"></a></p></div></div>", 1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row justify-center\"><p class=\"mt-4\"><a href=\"https://centroderelevo.gov.co/632/w3-propertyvalue-15253.html\" target=\"_blank\"><img src=\"" + _imports_2 + "\" class=\"h-10\" alt=\"CentrodeRelevoMinticCall\"></a></p><p class=\"mt-4 ml-2\"><a href=\"https://convertic.gov.co/641/w3-channel.html\" target=\"_blank\"><img src=\"" + _imports_3 + "\" class=\"h-10\" alt=\"CentrodeRelevoMinticCallConVer\"></a></p><p class=\"mt-4 ml-2\"><a href=\"https://centroderelevo.gov.co/632/w3-propertyvalue-15254.html\" target=\"_blank\"><img src=\"" + _imports_4 + "\" class=\"h-10\" alt=\"CentrodeRelevoMinticInt\"></a></p></div>", 1)
const _hoisted_22 = { class: "mt-8 text-center text-base text-white" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-center text-base text-white" }, [
  /*#__PURE__*/_createTextVNode(" Designed and developed with 🧡 by "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-white hover:text-white",
    target: "_blank",
    href: "https://andrea.com.co"
  }, "Andrea.com.co.")
], -1)

import { defineComponent, h } from "vue";
import "../../styles/app.css";


export default /*#__PURE__*/_defineComponent({
  props: {
  banner: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const navigation = {
  main: [
    { name: "Inicio", href: "/" },
    { name: "Nosotros", href: "/nosotros" },
    { name: "Documentos", href: "/documentos" },
    { name: "Consultas", href: "/consultas" },
    { name: "Publicaciones", href: "/resoluciones" },
    { name: "Transparencia", href: "/transparencia" },
    { name: "Normatividad", href: "/normatividad" },
    { name: "Licencias", href: "/licencias" },
    { name: "Contacto", href: "/contacto" },
    { name: "PQRS", href: "https://forms.gle/CZ6s1iMWAJnmNygS8" },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/curaduria.segunda",
      icon: defineComponent({
        render: () =>
          h("svg", { fill: "currentColor", viewBox: "0 0 24 24" }, [
            h("path", {
              "fill-rule": "evenodd",
              d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
              "clip-rule": "evenodd",
            }),
          ]),
      }),
    },
  ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    (props.banner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.main, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "px-5 py-2"
          }, [
            _createElementVNode("a", {
              href: item.href,
              target: item.name === 'PQRS' ? '_blank' : '',
              class: "text-base text-white"
            }, _toDisplayString(item.name), 9, _hoisted_5)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.social, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.name,
            href: item.href,
            target: "_blank",
            class: "text-white"
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1),
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
              class: "h-6 w-6",
              "aria-hidden": "true"
            }))
          ], 8, _hoisted_7))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("footer.name")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("contact.address")), 1),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("contact.telephone")), 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("contact.cellphone")), 1),
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("contact.scheduleFooter")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("contact.scheduleHor")), 1)
          ])
        ]),
        _hoisted_20
      ]),
      _hoisted_21,
      _createElementVNode("p", _hoisted_22, " © " + _toDisplayString(new Date().getFullYear()) + " All rights reserved. Curaduria Urbana 2 de Montería. ", 1),
      _hoisted_23
    ])
  ]))
}
}

})